import { ErrorOutline } from "@mui/icons-material"
import { Box, Typography } from "@mui/material"
import { Error } from "services"
import { Center } from "./Center"
import { Placeholder } from "./Placeholder"

interface ErrorHandlerProps {
    error?: Error
  }
  
  export function ErrorHandler({ error, children }: React.PropsWithChildren<ErrorHandlerProps>) {
    if(error) {
      console.log(error)
      return <Center>
        <Box m={2}>
          <ErrorOutline style={{ fontSize: 72 }} />
        </Box>
        <Typography variant="h4">Unexpected error</Typography>
        <Placeholder>{ error.message }</Placeholder>
      </Center>
    } else {
      return <>{ children }</>
    }
  }